const getDefaultState = () => {
    return {
        categories: [],
    };
};

// initial state
const state = getDefaultState();

const mutations = {
    RESET_STATE(state) {
        Object.assign(state, getDefaultState());
    },
    SET_CATEGORIES(state, payload) {
        state.categories = payload;
        state.categories.push({ id: "all", name: "TODOS" });
    },
};

const actions = {
    resetStateFeePayment({ commit }) {
        commit('RESET_STATE');
    },
    setCategories({ commit }, payload) {
        commit('SET_CATEGORIES', payload);
    },
};

export default {
    state,
    getters: {
        getCategories(state) {
            return state.categories;
        }
    },
    actions,
    mutations
};
